import { render, staticRenderFns } from "./MdSkeleton.vue?vue&type=template&id=70c856f3&scoped=true&"
import script from "./MdSkeleton.vue?vue&type=script&lang=js&"
export * from "./MdSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./MdSkeleton.vue?vue&type=style&index=0&id=70c856f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c856f3",
  null
  
)

export default component.exports